export default __webpack_public_path__ + "static/media/GellixIT-Regular.ab9101ef.woff2";